import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { withStyles } from "@material-ui/core/styles"
import { withTranslation } from "react-i18next"
import { compose } from "redux"

import { Checkbox as CheckboxSem } from "semantic-ui-react"

import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"

import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"

import contactUsStyle from "assets/jss/material-kit-pro-react/views/contactUsStyle.js"
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.js"

import Config from "config"
import axios from "axios"
import secureStorage from "libs/secureStorage"
import { fnumber } from "components/Helper"

const style = (theme) => ({
	...modalStyle(theme),
	...contactUsStyle,
})

const PLN_PRODUCTS = [
	{
		key: "plnPostpaid",
		label: "PLN POSTPAID",
		productId: 14,
		stateAdmins: "adminsPostpaid",
		stateSelected: "singleAdminPostpaid",
	},
	{
		key: "plnPrepaid",
		label: "PLN PREPAID",
		productId: 15,
		stateAdmins: "adminsPrepaid",
		stateSelected: "singleAdminPrepaid",
	},
	{
		key: "plnPrepaidSmall",
		label: "PLN PREPAID SMALL",
		productId: 16,
		stateAdmins: "adminsPrepaidSmall",
		stateSelected: "singleAdminPrepaidSmall",
	},
	{
		key: "plnNontaglis",
		label: "PLN NONTAGLIS",
		productId: 984,
		stateAdmins: "adminsNontaglis",
		stateSelected: "singleAdminNontaglis",
	},
]

class SingleAdmin extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			user: null,
			isSingleAdmin: false,
			adminsPostpaid: [],
			adminsPrepaid: [],
			adminsPrepaidSmall: [],
			adminsNontaglis: [],
			singleAdminPostpaid: "ALL",
			singleAdminPrepaid: "ALL",
			singleAdminPrepaidSmall: "ALL",
			singleAdminNontaglis: "ALL",
		}
	}

	componentDidMount() {
		const user = secureStorage.getItem("user")
		if (user) {
			this.setState({ user, isSingleAdmin: user.isSingleAdmin || false })
			if (user.isSingleAdmin) {
				this.loadSingleAdmin(user)
			}
		}
	}

	loadSingleAdmin = (user) => {
		const currentUser = user || this.state.user
		axios
			.post(Config.ApiUrl + "/user/singleadmin/get", { selectedUser: currentUser })
			.then(({ data }) => {
				if (data) {
					this.setState({
						singleAdminPostpaid: data["14"] || "ALL",
						singleAdminPrepaid: data["15"] || "ALL",
						singleAdminPrepaidSmall: data["16"] || "ALL",
						singleAdminNontaglis: data["984"] || "ALL",
					})
				}
			})
			.catch((error) => {
				console.log(error)
			})
		PLN_PRODUCTS.forEach(({ productId, stateAdmins }) => {
			this.loadAdminsForProduct(productId, stateAdmins)
		})
	}

	loadAdminsForProduct = (productId, stateKey) => {
		axios
			.post(Config.ApiUrl + "/product/admin/get", { productId })
			.then((res) => {
				this.setState({ [stateKey]: res.data || [] })
			})
			.catch((error) => {
				console.log(error)
			})
	}

	saveSingleAdmin = (productId, adminId) => {
		const { user } = this.state
		axios
			.post(Config.ApiUrl + "/user/singleadmin/set", {
				selectedUser: user,
				productId,
				adminId,
			})
			.then(() => {
				console.log("ok")
			})
			.catch((error) => {
				console.log(error)
			})
	}

	handleToggle = (checked) => {
		const { user } = this.state
		const isSingleAdmin = checked
		axios
			.post(Config.ApiUrl + "/user/issingleadmin", {
				userId: user.id,
				isSingleAdmin,
			})
			.then(() => {
				const updatedUser = { ...user, isSingleAdmin }
				secureStorage.setItem("user", updatedUser)
				this.setState({ isSingleAdmin, user: updatedUser })
				if (isSingleAdmin) {
					this.loadSingleAdmin()
				}
			})
			.catch((error) => {
				console.log(error)
			})
	}

	render() {
		const { classes } = this.props
		const { isSingleAdmin } = this.state

		return (
			<div className={classNames(classes.main, classes.mainRaised)}>
				<div className={classes.contactContent}>
					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xl={12} lg={12} md={12} sm={12} xs={12}>
								<h4>Single Admin Setting</h4>
							</GridItem>

							{/* Toggle Single Admin */}
							<GridItem xl={12} lg={12} md={12} sm={12} xs={12} style={{ marginTop: 10 }}>
								<CheckboxSem
									toggle
									label="Single Admin"
									checked={isSingleAdmin}
									onClick={(_, { checked }) => this.handleToggle(checked)}
								/>
							</GridItem>

							{/* Section PLN - tampil hanya jika Single Admin ON */}
							{isSingleAdmin && (
								<GridItem xl={12} lg={12} md={12} sm={12} xs={12} style={{ marginTop: 20 }}>
									<GridContainer justify="center">
										{PLN_PRODUCTS.map(({ key, label, productId, stateAdmins, stateSelected }) => (
											<GridItem key={key} xl={3} lg={3} md={3} sm={12} xs={12} style={{ marginTop: 10 }}>
												<FormControl fullWidth className={classes.selectFormControl}>
													<InputLabel htmlFor={key} className={classes.selectLabel}>
														{label}
													</InputLabel>
													<Select
														MenuProps={{ className: classes.selectMenu }}
														classes={{ select: classes.select }}
														inputProps={{ name: key, id: key }}
														value={this.state[stateSelected]}
														onChange={(e) => {
															const adminId = e.target.value
															this.setState({ [stateSelected]: adminId })
															this.saveSingleAdmin(productId, adminId)
														}}
													>
														<MenuItem classes={{ root: classes.selectMenuItem }} value="ALL">
															-- Pilih Admin --
														</MenuItem>
														{this.state[stateAdmins].map((admin, index) => (
															<MenuItem
																key={index}
																classes={{
																	root: classes.selectMenuItem,
																	selected: classes.selectMenuItemSelected,
																}}
																value={admin.id}
															>
																{fnumber(admin.nominal)}
															</MenuItem>
														))}
													</Select>
												</FormControl>
											</GridItem>
										))}
									</GridContainer>
								</GridItem>
							)}
						</GridContainer>
					</div>
				</div>
			</div>
		)
	}
}

SingleAdmin.propTypes = {
	classes: PropTypes.object.isRequired,
}

export default compose(withTranslation(), withStyles(style))(SingleAdmin)
